import React, { useEffect } from "react"
import Select from "react-select";


const SelectOptions = ({ Service, label, setOptions, placeholder, options, handleSelectChange, selectedOption, ...otherProps }) => {
    const service = new Service()
    useEffect(() => {
        service.getDropDown().then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: item.name.en ?item.name.en :item.name,
                    value: item.id
                }
            })
            setOptions(newOptions)
        })
    }, [])

    return (
        <>
            <label>{label}</label>
            <Select
                placeholder={placeholder}
                options={options}
                className='mb-3'
                onChange={(data) => {
                    handleSelectChange(data)
                }}
                value={selectedOption}
                {...otherProps}
            />
        </>
    )
}

export default SelectOptions